// removed by extract-text-webpack-plugin
module.exports = {"ant-form-item":"ant-form-item","ant-form-item-label":"ant-form-item-label"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/sendSolicitations/SendSolicitation.scss
// module id = 5164
// module chunks = 1